import { render } from "./questioneditorgverb.vue?vue&type=template&id=b0c64570&scoped=true"
import script from "./questioneditorgverb.vue?vue&type=script&lang=js"
export * from "./questioneditorgverb.vue?vue&type=script&lang=js"

import "./questioneditorgverb.vue?vue&type=style&index=0&id=b0c64570&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c64570"]])

export default __exports__